import { render, staticRenderFns } from "./ItemPartner.vue?vue&type=template&id=2b183604&scoped=true"
import script from "./ItemPartner.vue?vue&type=script&lang=js"
export * from "./ItemPartner.vue?vue&type=script&lang=js"
import style0 from "./ItemPartner.vue?vue&type=style&index=0&id=2b183604&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b183604",
  null
  
)

export default component.exports